import { useGetRewardDetailsQuery, useGetRewardTiersQuery } from "store/slices/rewards-api";

export function useCurrentRewardTier() {
    const { data: rewardDetails, isLoading: isLoadingDetails } = useGetRewardDetailsQuery();
    const { data: tiers, isLoading: isTiersLoading } = useGetRewardTiersQuery();

    const isLoading = isLoadingDetails || isTiersLoading;
    if (isLoading) {
        return {
            currentTier: null,
            isLoading,
        };
    }

    const currentTier = tiers?.find(tier => tier.tierId === rewardDetails?.currentRewardTierId);
    return {
        currentTier,
        isLoading,
    };
}
